import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { RootState } from "../reducers";
import useEffectOnce from "../hooks/useEffectOnce";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Navigate, useNavigate } from "react-router-dom";
import { fetchdata, viewdata } from '../reduxactions/donorrsactions/DFeedbackAction'
import { Dialog } from "primereact/dialog";
import { GFNButton } from "../ui";
import { Panel } from "primereact/panel";
import { Tag } from "primereact/tag";

export const DonorFeedback = () => {

    const [globalFilter, setGlobalFilter] = useState('');

    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()

    const data = useSelector((state: RootState) => state.dfeedback.data);
    const viewdatas = useSelector((state: RootState) => state.dfeedback.dataview);

    // To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])

    //To assign data 
    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }


    const viewupload = (rowData: any) => {

        assignData.current = { Feedback_id: rowData.Feedback_id }

        setfield(true);
        fetchDataAsyncdialog();
    };
    const assignData = useRef({ Feedback_id: '' })
    const fetchDataAsyncdialog = async () => {
        try {
            const { Feedback_id } = assignData.current;
            console.log("Feedback_id", Feedback_id)
            await dispatch(viewdata(uid, Feedback_id) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };
    const navigate = useNavigate();

    const Donates = () => {
        const url = `/addfeedback`;

        // Use navigate to navigate to the URL
        navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donor-feedbacks.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-1">
                                    <div className="col-9">
                                        <h1>Feedback</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Feedback</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        {/* <section className="content"> */}
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card flex flex-wrap justify-content-end">

                                        {/* <Button data-testid="add-feedback-btn" className='mr-1' severity="info" label="Add Feedback" rounded onClick={() => Donates()} /> */}
                                        <GFNButton data-testid="add-feedback-btn" buttonType="primary" label="Add Feedback" onClick={() => Donates()} />
                                    </div>

                                    <div className="card flex flex-wrap justify-content-end my-2">
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search ml-2" />

                                            <InputText
                                                className="app-search-input"
                                                value={globalFilter}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                                placeholder="Global Search"
                                            />
                                        </span>
                                    </div>
                                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                        <Column field="date" sortable header="Date"></Column>
                                        <Column field="firstName" sortable header="Name"></Column>
                                        <Column field="description" sortable header="Description"></Column>

                                        <Column header="Operation" body={(rowData, { rowIndex }) => (
                                            <div>
                                                {/* <Button data-testid={`view-btn-${rowIndex}`} icon="pi pi-eye" tooltip="View" rounded outlined className='mr-1' onClick={() => viewupload(rowData)} style={{ color: 'blue' }} /> */}
                                                <GFNButton data-testid={`view-btn-${rowIndex}`} icon="pi pi-eye" tooltip="View" buttonType="primary" onClick={() => viewupload(rowData)} />
                                            </div>
                                        )}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </Panel>
                        {/* </section> */}
                        <Dialog
                            header="Request Details"
                            visible={acceptfield}
                            onHide={cancelfield}
                            style={{ width: "35vw" }}
                            breakpoints={{ "960px": "60vw", "640px": "95vw" }}
                            className="border-round-3xl"
                        >

                            {viewdatas.map((response: any, index: number) => (

                                <div key={index} className="p-3">

                                    {/* Profile Section */}
                                    <div className="flex align-items-center mb-4">

                                        <div
                                            className="flex align-items-center justify-content-center border-circle shadow-2"
                                            style={{
                                                width: "70px",
                                                height: "70px",
                                                background: "#dbeafe"
                                            }}
                                        >
                                            <i
                                                className="pi pi-user text-3xl text-blue-500"
                                            ></i>
                                        </div>

                                        <div className="ml-3">
                                            <h2 className="m-0 text-900">
                                                {response.firstName}
                                            </h2>

                                            <p className="m-0 text-600">
                                                {response.usertype}
                                            </p>
                                        </div>

                                    </div>

                                    {/* Details Card */}
                                    <div
                                        className="border-1 border-200 border-round-2xl p-4 surface-50"
                                    >

                                        {/* Date */}
                                        <div className="flex justify-content-between align-items-center mb-4">
                                            <span className="font-semibold text-700">
                                                <i className="pi pi-calendar mr-2 text-blue-500"></i>
                                                Date
                                            </span>

                                            <span className="text-600">
                                                {response.date}
                                            </span>
                                        </div>

                                        {/* Name */}
                                        <div className="flex justify-content-between align-items-center mb-4">
                                            <span className="font-semibold text-700">
                                                <i className="pi pi-user mr-2 text-green-500"></i>
                                                Name
                                            </span>

                                            <span className="text-600">
                                                {response.firstName}
                                            </span>
                                        </div>

                                        {/* Type */}
                                        <div className="flex justify-content-between align-items-center mb-4">
                                            <span className="font-semibold text-700">
                                                <i className="pi pi-tag mr-2 text-orange-500"></i>
                                                Type
                                            </span>

                                            <Tag
                                                value={response.usertype}
                                                severity="info"
                                            />
                                        </div>

                                        {/* Description */}
                                        <div className="mb-2">
                                            <span className="font-semibold text-700 block mb-3">
                                                <i className="pi pi-file-edit mr-2 text-purple-500"></i>
                                                Description
                                            </span>

                                            <div
                                                className="p-3 border-round-xl surface-0 border-1 border-200 text-600"
                                                style={{
                                                    lineHeight: "1.7"
                                                }}
                                            >
                                                {response.description}
                                            </div>
                                        </div>

                                    </div>

                                    {/* Footer Button */}
                                    <div className="flex justify-content-end mt-4">

                                        <GFNButton
                                            label="Close"
                                            icon="pi pi-times"
                                            className="ml-2"
                                            data-testid="cancel-btn"
                                            buttonType="secondary"
                                            onClick={cancelfield}
                                        />

                                    </div>

                                </div>

                            ))}

                        </Dialog>

                        {/* <Dialog header="Details" visible={acceptfield} onHide={cancelfield}>
                            <div className='grid pt-1'>
                            </div>
                            <form className="form-horizontal" action="" method="POST">
                                {viewdatas.map((response: any) =>
                                    <div className="row">
                                        <div className="grid">
                                            <div className="col-12" style={{ width: '20vw', height: '35vh' }}>
                                                <div className="grid pt-3"></div>
                                                <div className="row">
                                                    <div className="grid pt-2">
                                                        <div className="col-6" >
                                                            Date  :
                                                        </div>
                                                        <div className="col md-3" >
                                                            {response.date}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='grid pt-3' ></div>

                                                <div className="row">
                                                    <div className="grid pt-2">
                                                        <div className="col-6" >
                                                            Name :
                                                        </div>
                                                        <div className='col md-4'>
                                                            {response.firstName}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='grid pt-3'></div>
                                                <div className="row">
                                                    <div className="grid pt-2">
                                                        <div className="col-6" >
                                                            Type :
                                                        </div>
                                                        <div className='col md-4'>
                                                            {response.usertype}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='grid pt-3'></div>
                                                <div className="row">
                                                    <div className="grid pt-2">
                                                        <div className="col-6" >
                                                            Description:
                                                        </div>
                                                        <div className='col md-4'>
                                                            {response.description}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </form>
                            <Button label="Close" className="ml-2" severity="secondary" data-testid="view-close-btn" onClick={cancelfield} />
                        </Dialog> */}

                    </div>
                </div>
            </div>
        </div>
    )
}
export default DonorFeedback;
